"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechRecognitionFailedError = exports.MicrophoneNotAllowedError = void 0;
/**
 * Error emitted when the user does not give permission to use the microphone
 * @public
 */
exports.MicrophoneNotAllowedError = {
    error: 'not-allowed',
    message: 'User did not give permission to use the microphone',
};
/**
 * Generic error when speech recognition fails due to an unknown cause
 * @public
 */
exports.SpeechRecognitionFailedError = {
    error: 'audio-capture',
    message: 'Speech recognition failed',
};
//# sourceMappingURL=types.js.map